import React, { FC } from "react";
import { RetailLocation } from "evcharging/services/types";
import retailPrices, { higherPrice } from "utils/retail/prices";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";
import Spacer from "evcharging/components/Spacer";
import RatesConsultationForm from "containers/retail/sections/energy-rates-3/RatesConsultationForm";
import useI18n from "evcharging/hooks/useI18n";

interface RatesNoDataBoxProps {
  retailLocation?: RetailLocation;
  zipCode: string;
  utilityName: string;
  customerType: string;
}

const RatesNoDataBox: FC<RatesNoDataBoxProps> = (props) => {
  const { retailLocation, ...rest } = props;
  const { t } = useI18n();
  const hasLocation = !!retailLocation;
  const rate = hasLocation ? retailPrices[retailLocation.st] || higherPrice : higherPrice;
  const locationText = hasLocation
    ? `${retailLocation.city}, ${retailLocation.state}`
    : t('rates.your-location');

  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <>
      <div className={styles.wrapper}>
        <Spacer value={8} />
        <div className={styles.title}>
          {t('rates.your-rate-is-n', { rate })}
          <div className={styles.unit}>/ {t('rates.per-kwh')}</div>
        </div>
        <Spacer value={8} />
        <div className={styles.text}>
          {t('rates.no-data-info', { locationText })}
        </div>
      </div>
      <div className={styles.formBox}>
        <div className={styles.subTitle}>
          {t('rates.leave-info')}
        </div>
        <RatesConsultationForm {...rest} />
      </div>
    </>
  );
};

const createStyles = (theme: Theme) => (
  {
    wrapper: css({
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: theme.spacing(3.75),
      padding: 40,
      backgroundColor: "white",
      boxShadow: "0 3px 5px rgba(0, 0, 0, .05)",
      borderRadius: 6
    }),
    title: css({
      fontSize: 21,
      fontWeight: 700,
      lineHeight: "150%",
      textAlign: "center",
      [theme.breakpoints.mobile.up]: {
        fontSize: 32
      }
    }),
    text: css({
      fontSize: 18,
      fontWeight: 500,
      lineHeight: "150%",
      maxWidth: 840,
      textAlign: "center"
    }),
    unit: css({
      display: "inline",
      fontSize: 16,
      fontWeight: 600,
      lineHeight: "150%",
      [theme.breakpoints.mobile.up]: {
        fontSize: 18
      }
    }),
    subTitle: css({
      fontWeight: 400,
      fontSize: 16,
      color: "#979797",
      marginBottom: 24
    }),
    formBox: css({
      padding: '25px 12px',
      borderRadius: 6,
      boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.05);',
      backgroundColor: '#ffffff',
      [theme.breakpoints.mobile.up]: {
        padding: 25,
      },
    }),
  }
);

export default RatesNoDataBox;
